import { render, staticRenderFns } from "./AccordionView.DynamicView.vue?vue&type=template&id=563e97c6"
import script from "./AccordionView.DynamicView.vue?vue&type=script&lang=ts"
export * from "./AccordionView.DynamicView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports